// Recovered compiled webpack factory 76248. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      dispatchAppRouterAction: function () {
        return i;
      },
      useActionQueue: function () {
        return s;
      },
    }));
  let n = r(49417)._(r(12115)),
    a = r(54089),
    o = null;
  function i(e) {
    if (null === o)
      throw Object.defineProperty(
        Error("Internal Next.js error: Router action dispatched before initialization."),
        "__NEXT_ERROR_CODE",
        { value: "E668", enumerable: !1, configurable: !0 },
      );
    o(e);
  }
  function s(e) {
    let [t, r] = n.default.useState(e.state);
    return ((o = (t) => e.dispatch(t, r)), (0, a.isThenable)(t) ? (0, n.use)(t) : t);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
